import { acceptHMRUpdate, defineStore } from 'pinia';
import { AdditionalPrimary } from '@/types/pages/candidate/additional';

const initialState: AdditionalPrimary = {
  zip_code: undefined,
  country_id: undefined,
  prefecture_id: undefined,
  city_id: undefined,
  address: undefined,
  tel: undefined,
  is_married: undefined,
  willingness: undefined,
  gender: '3',
};

export const useAdditionalStore = defineStore('additional.store', {
  state: (): AdditionalPrimary => ({ ...initialState }),
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAdditionalStore, import.meta.hot));
}
